import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {months} from '../../../config/pillveryVariables';

export default function SalesForYearChart(typeChart = '') {

  const {statistics, loading} = useSelector(state => state.Dashboard);
  const chartRef = useRef();

  useEffect(() => {
    if (chartRef && chartRef.current) {
      var purchasesChartCanvas = chartRef?.current?.getContext('2d');
      var purchasesChart = new window.Chart(purchasesChartCanvas, {
        type: 'bar',
        data: {
          labels: statistics?.completedOrdersPerMonth?.count_by_date?.sort(
              (a, b) => a['_id']['year'] - b['_id']['year'] ||
                  a['_id']['month'] - b['_id']['month']).map(item => {
            const monthName = months[item['_id']['month'] - 1 || 0];
            return monthName + ' ' + item['_id']['year'];
          }),
          datasets: [
            {
              label: 'Orders',
              data: statistics?.completedOrdersPerMonth?.count_by_date?.map(
                  item => {
                    return item['total'];
                  }),
              backgroundColor: '#fbbc06',
              yAxisID: 'y0',

            },
            {
              label: 'Sales',
              data: statistics?.completedOrdersPerMonth?.count_by_date?.map(
                  item => {
                    return item['total_paid'];
                  }),
              backgroundColor: '#418FDE',
              yAxisID: 'y1',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          scales: {
            yAxes: [
              {
                id: 'y0',
                display: true,
                gridLines: {
                  drawBorder: false,
                  color: '#f1f3f9',
                  zeroLineColor: '#f1f3f9',
                },
                ticks: {
                  min: 0,
                  // max: 600,
                  // stepSize: 200,
                  fontColor: '#979797',
                  fontSize: 11,
                  fontStyle: 400,
                  padding: 15,
                },
                // ,
                // ticks: {
                //     display: false,
                //     fontColor: "#9fa0a2",
                //     padding: 0,
                //     stepSize: 20,
                //     min: 0,
                //     max: 100
                // }

              },
              {
                id: 'y1',
                display: true,
                // gridLines: {
                //   drawBorder: false,
                //   color: '#f1f3f9',
                //   zeroLineColor: '#f1f3f9',
                // },
                position: 'right',
                // type: 'linear',
                ticks: {
                  // min: 0,
                  // max: 600,
                  // stepSize: 200,
                  fontColor: '#979797',
                  fontSize: 11,
                  fontStyle: 400,
                  padding: 15,
                },
              }],
            xAxes: [
              {
                // stacked: true,
                // categoryPercentage: 1,
                ticks: {
                  beginAtZero: true,
                  display: true,
                  padding: 10,
                  fontSize: 11,
                  fontColor: '#979797',
                },
                gridLines: {
                  color: 'rgba(0, 0, 0, 0)',
                  display: true,
                },
                position: 'bottom',
                // barPercentage: 0.4,
              }],
          },
          legend: {
            display: false,
          },
          elements: {
            point: {
              radius: 0,
            },
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                const data = statistics.completedOrdersPerMonth.count_by_date[tooltipItem.index];
                let rev = data.total_paid;

                // if(tooltipItem.index == statistics.completedOrdersPerMonth.count_by_date.length - 1) {
                //     rev = statistics.revenueThisMonth.total_orders_revenue;
                // }

                if (tooltipItem.datasetIndex === 0) {
                  return `Orders: ${data.total}`;
                } else {
                  return `Sales: ${rev}`;
                }
              },
            },
          },
        },
      });
    }
  }, [statistics]);

  return (
      <>
        <canvas
            ref={chartRef}
            height="150"
        >
        </canvas>
      </>
  );
}